import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { LayoutSingleColumn, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import PremiumPartnerTiles from './components/PremiumPartnerTile/PremiumPartnerTile';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { injectIntl } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';

import css from './PartnerPortal.module.css';

const PartnerPortalComponent = ({
  scrollingDisabled,
  intl,
  premiumPartners,
}) => {
  const config = useConfiguration();

  const schemaTitleVars = { name: "PartnerPortal", marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'PartnerPortal.schemaTitle' }, schemaTitleVars);

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'PartnerPortal',
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <div className={css.headline}>
            <h1 className={css.title}>{intl.formatMessage({ id: 'PartnerPortal.title' })}</h1>
            <p className={css.description}>{intl.formatMessage({ id: 'PartnerPortal.description' })}</p>
            <div className={css.divider} />
          </div>

          <PremiumPartnerTiles premiumPartners={premiumPartners} intl={intl} />
        </div>
      </LayoutSingleColumn>
    </Page>
  )
};

const mapStateToProps = state => {
  const {
    premiumPartners
  } = state.PartnerPortal;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    premiumPartners
  };
};

const PartnerPortal = compose(
  connect(mapStateToProps),
  injectIntl
)(PartnerPortalComponent);

export default PartnerPortal;
